import { IInstitutionContact } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';
import { InstitutionContactWorkItem } from 'src/app/business/institution/institution-contact-work-item';

@Injectable()
export class InstitutionContactCommandHandler extends EntityCommandHandler<IInstitutionContact> {
  protected workItem: IWorkItem<IInstitutionContact>;

  constructor(institutionContactWorkItem: InstitutionContactWorkItem) {
    super();
    this.workItem = institutionContactWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'InstitutionContactDto';
  }
}
